import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import enTranslations from '../locales/en/translation.json';
import esTranslations from '../locales/es/translation.json';

export default () => {
    i18n
        .use(Backend)
        .use(LanguageDetector)
        .init({
            fallbackLng: 'en',
            // lng: 'en',
            debug: true,
            interpolation: { escapeValue: false },
            backend: {
                loadPath: '/locales/{{lng}}/{{ns}}.json',
                crossDomain: false
            },
            detection: {
                order: ['querystring', 'navigator', 'cookie'], // Order of detection methods
                caches: [], // Caches language detection result in cookie
                lookupQuerystring: 'lng', // query string parameter to look for
                lookupCookie: 'i18next', // name of cookie
                lookupLocalStorage: 'i18nextLng' // name of local storage
            },
            resources: {
                en: { translation: enTranslations }, // English
                es: { translation: esTranslations }, // Spanish
                // add your translation here...
            },
        });

    window.i18n = i18n;
    window._t = i18n.t;
}